import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/state/authStore';

interface Props {
  children: React.ReactNode;
}

export function RequireAuth({ children }: Props) {
  const { isAuthenticated, initializing, initialize } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (initializing) {
      initialize();
    }
  }, [initializing, initialize]);

  if (initializing) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-gray-500">認証情報を確認しています...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
